const $doc = $(document);
const $win = $(window);
const $field = $('.field-secondary');

function checkField($element) {
  const $this = $element;

  if ($this.val() == '') {
    $this
      .parent()
      .removeClass('alt');
  } else {
    $this
      .parent()
      .addClass('alt');
  }
}

function checkSelect($select, $option) {
  if ($select.is(':disabled')) {
    $select
      .parent()
      .removeClass('alt');
  } else {
    if ($option.val() == '') {
      $select
        .parent()
        .removeClass('alt');
    } else {
      $select
        .parent()
        .addClass('alt');
    }
  }
}

$field.each(function() {
  checkField($(this));
});

$doc
  .on('blur input focusout','.field-secondary, .js-customer-fields .fields input:not([type="submit"]):not([type="radio"]):not([type="checkbox"])', function() {
    checkField($(this));
  })
  .on('focusin','.field-secondary, .js-customer-fields .fields input:not([type="submit"]):not([type="radio"]):not([type="checkbox"])', function() {
    const $this = $(this);
    
    $this
      .parent()
      .addClass('alt');
  })

$doc.on('change', '.js-customer-fields .fields select', function() {
  const $this = $(this);
  const $otherSelects = $this.closest('.customr-container-item').siblings().find('select');

  checkSelect($this, $this.find('option:selected'))

  if ($otherSelects.length) {
    checkSelect($otherSelects, $otherSelects.find('option:selected'));
  };
});


const $fields = $('.js-customer-fields .fields');

if ($fields.length) {
  var targetNode = $fields[0];
  var config = { childList: true, subtree: true };

  var callback = function(mutationsList, observer) {
    $fields.find('input:not([type="submit"]):not([type="radio"]):not([type="checkbox"])').each(function() {
      checkField($(this));
    });

    $fields.find('select').each(function() {
      const $this = $(this);

      checkSelect($this, $this.find('option:selected'))
    });

    observer.disconnect();
  };

  var observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}

$doc.on('click', '.js-form-edit input[type="submit"]', function() {
  setTimeout(function() {
    location.reload();
  }, 600);
});

module.exports = {
  checkField
};



// WEBPACK FOOTER //
// ../assets/js/form-actions.js